export const countriesIds = {
	kz: 398,
}

export const workingTimeMode = {
	partTime: 3,
}
